const BaseService = require('@/services/BaseService')

const namespace = 'reservations/types'

const find = (id, options, cb) => {
  BaseService.get(namespace + '/' + id, options, cb);
}

const findAll = (options, cb) => {
  BaseService.get(namespace, options, cb);
}

export {
  find,
  findAll
}


// WEBPACK FOOTER //
// ./src/services/reservations/TypeService.js